export default __webpack_public_path__ + "static/media/df1d4c03357e4b9a4e00623e7012c624.svg";